module.exports = __webpack_public_path__ + "static/media/my-qr-add-member.c9ad7713.png";